export default __webpack_public_path__ + "static/media/social.6f36259d.png";